// import React from 'react'

// const TPDSMyTargetReport = () => {
//   return (
//     <div>TPDSMyTargetReport</div>
//   )
// }



import { format } from "date-fns";
import React, { useState, useEffect } from 'react';
import './TPDSMyTargetReport.css';
import axios from "axios";
import { jsPDF } from 'jspdf';
import ExcelJS from 'exceljs';
import pds from './pds.PNG';
const TPDSMyTargetReport = () => {
    // const [stockData ,setStockData]=useState('');
    const [error, setError] = useState(null);
    const [stockData, setStockData] = useState([]);

    const [userInfo, setUserInfo] = useState({

        // displayName: '',
        // empId: ''
        fullName: '',
        employeeId: '',
        roleName: '',
        username: '',

    });
    const [isLoggedIn, setIsLoggedIn] = useState(false);  // Track login state


    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
            const firstName = userData.fullName.split(' ')[0];
            // console.log("User Data:", userData); // Check user data
            setUserInfo({
                fullName: firstName,
                employeeId: userData.employeeId,
                roleName: userData.roleName,
                username: userData.username,
            });
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
    }, []);

    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    //const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const baseUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;  // Define the base URL
    useEffect(() => {
        if (token && userInfo.username) {
             axios.get(`${baseUrl}/getGodownTargetReport/${userInfo.username}/type/2`, {
           // axios.get(`http://3.111.123.209:1337/api/getGodownTargetReport/ashaK/type/2`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {
                        setStockData(response.data.data);
                        //  console.log(response.data);
                    } else {
                        setError("Invalid response format");
                    }
                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("Username is missing or token is invalid. Please log in.");
        }
    }, [token, userInfo.username]); // Added userInfo.username in dependency array



    const downloadPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9, 1, 193, 36);  // Image format: 'PNG'
        doc.setFontSize(18);
        // doc.text('Ongoing Inspections Today', 60, 40);

        const currentDate = new Date();

        // Format the date as dd-mm-yyyy
        const day = String(currentDate.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Get month (months are 0-indexed)
        const year = currentDate.getFullYear(); // Get the year

        const formattedDate = `${day}-${month}-${year}`; // Format as dd-mm-yyyy

        // Now use the formatted date in doc.text()
        doc.text('TPDS My Target Report', 70, 40);


        let currentYPosition = 44;



        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, 196, currentYPosition + 3, { align: 'right' });
        currentYPosition += 5;


        let currentXPosition = 20;
        const headers = ['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'Godown ID', 'Inspecting Date', 'Status',];
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.district?.districtName || 'N/A'),
            capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.subDivisionName || 'N/A'),
            capitalizeFirstLetter(data.godown?.panchayat?.block?.blockName || 'N/A'),
            capitalizeFirstLetter(data.godown?.panchayat?.panchayatName || 'N/A'),
            data.godown?.godownId,
            // data.poimsUser?.fullname || 'N/A',
            // format(new Date(data.date), 'dd-MM-yyyy'),
            data.dateOfInspection ? format(new Date(data.dateOfInspection), 'dd-MM-yyyy') : '-',
            data.inspectionStatus || "Pending",
            // data.designation,
        ]);
        doc.autoTable({
            head: [headers],
            body: rows,
            startY: currentYPosition,
            startX: currentXPosition,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },  // S.No - Center alignment
                1: { cellWidth: 22, halign: 'left' },    // District - Left alignment
                2: { cellWidth: 25, halign: 'left' },    // Subdivision - Left alignment
                3: { cellWidth: 20, halign: 'left' },    // Block Name - Left alignment
                4: { cellWidth: 30, halign: 'left' },    // Panchayat Name - Left alignment
                5: { cellWidth: 25, halign: 'right' },   // FPS ID - Right alignment
                6: { cellWidth: 30, halign: 'right' },   // Start Time - Right alignment
                7: { cellWidth: 20, halign: 'left' },    // POIMS User - Left alignment
                // 8: { cellWidth: 25, halign: 'left' },
            },
            tableWidth: 'auto',
            margin: {
                horizontal: 10,
                top: 10,
                bottom: 10,
            },
            pageBreak: 'auto',
            showHead: 'firstPage',
            styles: {
                fontSize: 10,
                textColor: 0,
            },
            headStyles: {
                fontSize: 10,
                fontStyle: 'bold',
                textColor: [42, 109, 139],
                fillColor: [211, 211, 211],
            }
        });
        doc.save('TPDS_My_Target_Report.pdf');
    };
    // Function to download the table as an Excel file
    const downloadExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const currentDate = new Date();

        // Format the current date as dd-mm-yyyy
        const day = String(currentDate.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Get month (months are 0-indexed)
        const year = currentDate.getFullYear(); // Get the year

        const formattedDate = `${day}-${month}-${year}`; // Format as dd-mm-yyyy

        // Create a worksheet with the formatted date in its title
        const worksheet = workbook.addWorksheet(`TPDS My Target Report`);
        worksheet.mergeCells('A1:H1'); // Merge cells for the title
        worksheet.getCell('A1').value = `TPDS My Target Report`;
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getRow(1).font = { bold: true, size: 12 };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { size: 16, bold: true, color: { argb: 'F7912B' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' }  // Background color: Whitesmoke (ARGB format)
        };



        // const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        //  const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        worksheet.mergeCells('A2:H2'); // Merge cells for the title
        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        worksheet.getCell('A2').value = `Report Date :  ${formattedDateTime}`;
        worksheet.getRow(2).font = { bold: true, size: 12 };
        worksheet.getRow(2).alignment = { horizontal: 'right' };
        worksheet.getRow(2).font = { size: 11, bold: true, color: { argb: '000000' } };   // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' }  // Background color: Whitesmoke (ARGB format)
        };
        // Set column headers
        worksheet.addRow(['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'Godown ID', 'Inspecting Date', 'Status',]);//'Designation'

        // Apply header style: bold, size 12, and orange background


        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 8; col++) {
            const cell = worksheet.getCell(3, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }, // Orange background color

            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' }, };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 20 },  // Column C width
            { key: 'D', width: 20 },  // Column D width
            { key: 'E', width: 20 },  // Column E width
            { key: 'F', width: 25 },  // Column F width
            { key: 'G', width: 25 },  // Column D width
            { key: 'H', width: 18 },  // Column E width
            { key: 'I', width: 25 },
        ];

        // Add data rows from stockData
        stockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1,
                capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.district?.districtName || 'N/A'),
                capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.subDivisionName || 'N/A'),
                capitalizeFirstLetter(data.godown?.panchayat?.block?.blockName || 'N/A'),
                capitalizeFirstLetter(data.godown?.panchayat?.panchayatName || 'N/A'),
                data.godown?.godownId,
                // data.poimsUser?.fullname || 'N/A',
                // format(new Date(data.date), 'dd-MM-yyyy'),
                data.dateOfInspection ? format(new Date(data.dateOfInspection), 'dd-MM-yyyy') : '-',
                data.inspectionStatus || "Pending",
                // data.designation,

            ]);

            // Adjust alignment for 'fpsId' (column 6) and 'startTime' (column 7) and center 'S.No' (column 0)
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {  // Column 0 (S.No)
                    cell.alignment = { horizontal: 'center' };  // Center align for S.No
                } else if (colNumber === 6 || colNumber === 7) {  // Columns 6 (fpsId) and 7 (startTime)
                    cell.alignment = { horizontal: 'right' };  // Right align for fpsId and startTime
                } else {
                    cell.alignment = { horizontal: 'left' };  // Left align for all other columns
                }
            });

        });
        // Write Excel file to a buffer
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'TPDS_My_Target_report.xlsx';
            link.click();
        });
    };
    const capitalizeFirstLetter = (text) => {
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return '';
    };
    return (
        <div className="tpdsMyTargetReport">
            <div className="tpdsMyTargetReport-repo">

                <div className="tpdsMyTargetReport-header">
                    <button className="tpdsMyTargetReport-btn" onClick={downloadPDF}>DOWNLOAD PDF</button>
                    <button className="tpdsMyTargetReport-btn" onClick={downloadExcel}>DOWNLOAD XLSX</button>
                </div>
                <div className='cmrMyTarget-text'><h3>TPDS My Target Report</h3></div>
                <div className='cmrMyTarget-scroll'>
                    <table className="tpdsMyTargetReport-table">

                        <thead>
                            <tr className="tpdsMyTargetReport-tr">
                                <th>S.No</th>
                                <th>District</th>
                                <th>Sub-Division</th>
                                <th>Block</th>
                                <th>Panchayat</th>
                                <th>Godown ID</th>
                                <th>Inspection Date</th>
                                <th>Status</th>
                                {/* <th>Designation</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {stockData.map((data, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.district?.districtName)}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.subDivisionName)}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.block?.blockName)}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.panchayatName)}</td>
                                    <td>{data.godown?.godownId}</td>
                                    <td>{data.dateOfInspection ? format(new Date(data.dateOfInspection), 'dd-MM-yyyy') : '-'}</td>
                                    <td>{data.inspectionStatus || "Pending"}</td>
                                    {/* <td>{data.assignedBy?.fullname}</td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
export default TPDSMyTargetReport;